import { z } from "zod"

export const satelliteMosaicOptionSchema = z.enum(["cloudfree", "dehaze"])
export type SatelliteMosaicOption = z.infer<typeof satelliteMosaicOptionSchema>

const satelliteMosaicSchema = z.object({
    fileId: z.string(),
    minLng: z.number(),
    maxLng: z.number(),
    minLat: z.number(),
    maxLat: z.number(),
    minZoom: z.number().int().nonnegative(),
    maxZoom: z.number().int().nonnegative(),
    options: z.array(satelliteMosaicOptionSchema),
})

export const satelliteCallbackPayloadSchema = z.object({
    status: z.enum(["complete", "failed"]),
    error: z.string().optional(),
    errorCode: z.number().int().optional(),
    manifestFileId: z.string().optional(), // currently unused
    mosaics: z.array(satelliteMosaicSchema).optional(),
})
export type SatelliteCallbackPayload = z.infer<typeof satelliteCallbackPayloadSchema>
